module.exports = "<p class=\"control-label\">{{t('actionTimezone.closestCity')|e}}</p>\n<p>{{t(\"actionTimezone.tz.\" ~ userTimezone)|e}}</p>\n";
